var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          staticClass: "main-card-body",
          staticStyle: { "background-color": "#d6eeff" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-sm-1 text-centered",
                staticStyle: { margin: "auto" },
              },
              [
                _c("i", {
                  staticClass: "fi-checkbox icon-pending",
                  staticStyle: { "font-size": "40px" },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" }, [
              _c("p", [_c("strong", [_vm._v(_vm._s("Welcome to Pitaya!"))])]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      "Let's get your property set up. Complete these steps to start managing your property with Pitaya."
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-sm-2",
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "flex-end",
                },
              },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "outline-secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.finishLater()
                      },
                    },
                  },
                  [_vm._v("Finish Later")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.groups, function (group, index) {
        return index !== "offerings" || _vm.hasPOSAccess
          ? _c(
              "b-card",
              {
                key: index,
                staticClass: "main-card-body",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("h5", { staticClass: "card-header-title" }, [
                            _vm._v(_vm._s(group.grouptitle)),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _c("b-card-body", [
                  _c(
                    "div",
                    { staticClass: "container" },
                    _vm._l(group, function (step, index) {
                      return _c("div", { key: index }, [
                        index == "grouptitle"
                          ? _c("div", { staticStyle: { display: "hide" } })
                          : !step.optional
                          ? _c("div", { staticClass: "row" }, [
                              step.status === true
                                ? _c("div", { staticClass: "col-sm-1" }, [
                                    _c("i", {
                                      staticClass: "fi-checkbox icon-completed",
                                    }),
                                  ])
                                : step.status === false
                                ? _c("div", { staticClass: "col-sm-1" }, [
                                    _c("i", {
                                      staticClass: "fi-checkbox icon-pending",
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm" }, [
                                _c("p", [
                                  _c("strong", [_vm._v(_vm._s(step.title))]),
                                ]),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(step.description))]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-2 button-placement" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goToUrl(step.slug)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(step.buttonCopy))]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !step.optional ? _c("hr") : _vm._e(),
                      ])
                    }),
                    0
                  ),
                ]),
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "b-card",
        {
          staticClass: "main-card-body",
          staticStyle: { "background-color": "#d6eeff" },
        },
        [
          this.allStepsCompleted == true
            ? _c(
                "div",
                {
                  staticClass: "row",
                  staticStyle: { "justify-content": "center" },
                },
                [
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("setup.page.completed_note")) + " "),
                    ]),
                  ]),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "row",
                  staticStyle: { "justify-content": "center" },
                },
                [
                  _c("p", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("setup.page.incomplete_note"))),
                    ]),
                  ]),
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row",
              staticStyle: {
                "justify-content": "center",
                "padding-top": "20px",
              },
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.finalizeSetup()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("setup.page.complete_button")))]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.finishLater()
                    },
                  },
                },
                [_vm._v("Finish Later")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }